import type { Stroke } from '@etown/shared';

/** Zeichenflaeche des Whiteboards; Striche kommen auf 0..1 normalisiert an. */
export const BOARD_WIDTH = 880;
export const BOARD_HEIGHT = 540;

/**
 * Zeichnen eines Whiteboard-Strichs. Genutzt vom Modal und von der Kopie, die
 * in der Ego-Ansicht als Textur an der Wand haengt — beide malen dadurch
 * garantiert dasselbe Bild.
 */
export function drawStroke(ctx: CanvasRenderingContext2D, stroke: Stroke): void {
  if (stroke.points.length < 4) return;
  ctx.strokeStyle = stroke.color;
  ctx.lineWidth = stroke.width * BOARD_WIDTH;
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  ctx.beginPath();
  ctx.moveTo(stroke.points[0]! * BOARD_WIDTH, stroke.points[1]! * BOARD_HEIGHT);
  for (let i = 2; i < stroke.points.length; i += 2) {
    ctx.lineTo(stroke.points[i]! * BOARD_WIDTH, stroke.points[i + 1]! * BOARD_HEIGHT);
  }
  ctx.stroke();
}

/** Leeres, weisses Board. */
export function clearBoard(ctx: CanvasRenderingContext2D): void {
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, BOARD_WIDTH, BOARD_HEIGHT);
}
